import { render, staticRenderFns } from "./approve-opinion.vue?vue&type=template&id=13488505&scoped=true&"
import script from "./approve-opinion.vue?vue&type=script&lang=ts&"
export * from "./approve-opinion.vue?vue&type=script&lang=ts&"
import style0 from "./approve-opinion.vue?vue&type=style&index=0&id=13488505&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13488505",
  null
  
)

export default component.exports